export default {
  forcastOverviewBegin(state) {
    state.foLoading = true;
  },

  forcastOverviewSuccess(state, data) {
    state.foLoading = false;
    state.forcastData = data;
  },
  dashboardOverviewDataMemberSuccess(state, data) {
    state.foLoading = false;
    state.dashboardOverviewData.member = data;
  },

  dashboardOverviewDataOrderSuccess(state, data) {
    state.foLoading = false;
    state.dashboardOverviewData.order = data;
  },

  dashboardOverviewDataMessageSuccess(state, data) {
    state.foLoading = false;
    state.dashboardOverviewData.message = data;
  },

  dashboardOverviewDataReviewSuccess(state, data) {
    state.foLoading = false;
    state.dashboardOverviewData.review = data;
  },

  forcastOverviewErr(state, err) {
    state.foLoading = false;
    state.error = err;
  },
};
